/**
 * Displays price per unit information.
 *
 * @param {Object} props Component props
 * @param {number} props.price Price
 * @param {string} props.pricePerUnitBase Price per unit base unit of measure (typically lb)
 * @param {number} props.pricePerUnitRatio Ratio to multiply price by to get price per unit
 * @param {number} props.portion Portion of the product (bundles only)
 * @returns {JSX.Element}
 */
function PricePerUnitInfo({ portion = 1, price, pricePerUnitBase, pricePerUnitRatio }) {
    return (
        <p className="text-body-sm text-black">
            Est. ${((pricePerUnitRatio * price) / portion).toFixed(2)} / {pricePerUnitBase}
        </p>
    );
}

export default PricePerUnitInfo;
